import {
  checkboxTypeOperators,
  dateTypeOperators,
  numberTypeOperators,
  operators,
} from 'src/pages/workflow-builder-edit/conditions/constants';
import { CustomMetricsConditionOperators } from 'src/pages/workflow-builder-edit/types/canvasComponentTypes';
import { EventPropertyType } from 'src/services/custom-events/types';
import { ContextVariableTypes } from 'src/utils/enums';

// Hourly x_values arrive as ISO-8601 UTC instants; render them on the viewer's
// clock so the chart agrees with the conversation timestamps below it.
export function formatHourlyXValue(utcInstant: string): string {
  const date = new Date(utcInstant);

  if (isNaN(date.valueOf())) {
    return utcInstant;
  }

  return date.toLocaleString('en-us', {
    day: 'numeric',
    hour: 'numeric',
    month: 'short',
  });
}

export function getOperatorOptions(
  propertyType: EventPropertyType | keyof typeof ContextVariableTypes,
): {
  label: CustomMetricsConditionOperators;
  value: CustomMetricsConditionOperators;
}[] {
  if (propertyType === 'boolean' || propertyType === 'CHECKBOX') {
    return checkboxTypeOperators.map(
      operator =>
        ({
          label: operator,
          value: operator,
        }) as const,
    );
  }

  if (propertyType === 'number' || propertyType === 'NUMBER') {
    return numberTypeOperators.map(
      operator =>
        ({
          label: operator,
          value: operator,
        }) as const,
    );
  }

  if (propertyType === 'DATE') {
    return dateTypeOperators.map(
      operator =>
        ({
          label: operator,
          value: operator,
        }) as const,
    );
  }

  return operators.map(
    operator =>
      ({
        label: operator,
        value: operator,
      }) as const,
  );
}
